<template>
  <div class="core siteForm">
    <div class="layui-layer-title" style="cursor: move">{{ title }}</div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="tableForm" :rule="form_rule" :show-form="true" :after-save="handleAfterSave">
              <template slot-scope="{ scope }">
                <div class="layui-form">
                  <layui-collapse ref="collapse" class="">
                    <div class="layui-colla-item">
                      <h2 class="layui-colla-title">{{ info }}</h2>
                      <div class="layui-colla-content layui-show">
                        <div class="layui-form-item-two">
                          <div class="layui-form-item-left">
                            <div class="pub-form">
                              <div class="layui-form-item">
                                <label class="layui-form-label"> <span class="x-red">*</span>服务请求单编号：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <input
                                    v-if="input_disabled"
                                    type="text"
                                    v-model="scope.editRow.WORK_ORDER_NUM"
                                    autocomplete="off"
                                    :disabled="true"
                                    :class="'layui-input layui-disabled'"
                                    name="WORK_ORDER_NUM"
                                  />
                                  <layui-multiselect
                                    :single="true"
                                    v-if="type == 'yw' && !input_disabled"
                                    request-unique-id="getWorkNumList"
                                    ref="workOrderSelect"
                                    :enabled="work_order_enabled"
                                    :lazy="true"
                                    @selectChange="workOrderChange($event)"
                                    @modelChange="workOrderChange($event)"
                                    :renderText="renderWorkOrderText"
                                    table-name="YW_WORK_ORDER_DETAIL_V1"
                                    text-field="WORK_ORDER_NUM"
                                    value-field="WORK_ORDER_ID"
                                    :show-null-option="true"
                                    :sort="['YW_WORK_ORDER_CREATE_TIME:DESC']"
                                    :enable-search="true"
                                    name="F_WORK_ORDER_ID"
                                    v-model="scope.editRow.F_WORK_ORDER_ID"
                                  ></layui-multiselect>
                                  <layui-multiselect
                                    :single="true"
                                    v-if="type == 'gc' && !input_disabled"
                                    request-unique-id="getWorkNumList"
                                    ref="workOrderSelect"
                                    :enabled="work_order_enabled"
                                    :lazy="true"
                                    @selectChange="workOrderChange($event)"
                                    @modelChange="workOrderChange($event)"
                                    :renderText="renderWorkOrderText"
                                    table-name="YW_WORK_ORDER_DETAIL_V1"
                                    text-field="WORK_ORDER_NUM"
                                    value-field="WORK_ORDER_ID"
                                    :show-null-option="true"
                                    :sort="['YW_WORK_ORDER_CREATE_TIME:DESC']"
                                    :enable-search="true"
                                    name="F_WORK_ORDER_ID"
                                    v-model="scope.editRow.F_WORK_ORDER_ID"
                                  ></layui-multiselect>
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label"> <span class="x-red">*</span>服务商：</label>
                                <div class="layui-input-inline" style="width: 55%" id="servicer">
                                  <layui-multiselect
                                    ref="serviceSelect"
                                    :single="true"
                                    :enabled="true"
                                    name="SERVICE_ID"
                                    @selectChange="servicerSelectChange($event)"
                                    @modelChange="servicerModelChange($event)"
                                    :renderText="renderServiceText"
                                    table-name="YW_SERVICER"
                                    text-field="SERVICE_NAME"
                                    value-field="SERVICE_ID"
                                    :show-null-option="true"
                                    :queryCondition="{}"
                                    :enable-search="true"
                                    :sort="['CREATE_TIME:DESC']"
                                    v-model="scope.editRow.SERVICE_ID"
                                  ></layui-multiselect>
                                </div>
                                <span class="project-inner-add" @click="addService()" style="cursor: pointer">
                                  <i class="layui-icon layui-icon-add-circle" style="color: #00a0e9"></i>
                                  新增
                                </span>
                              </div>
                              <!--  :name="type==='gc'?'':'ENGINEER_ID'" -->
                              <div class="layui-form-item">
                                <label class="layui-form-label"> <span class="x-red">*</span>工程师：</label>
                                <div class="layui-input-inline" style="width: 55%" id="engineer">
                                  <layui-multiselect
                                    ref="engineerSelect"
                                    :single="true"
                                    :enabled="true"
                                    @selectChange="engineerChange($event)"
                                    :renderText="renderEngineerText"
                                    table-name="yw_engineer_v1"
                                    text-field="ENGINEER_NAME"
                                    value-field="ENGINEER_ID"
                                    :show-null-option="true"
                                    :queryCondition="{}"
                                    :enable-search="true"
                                    name="ENGINEER_ID"
                                    :sort="['CREATE_TIME:DESC']"
                                    v-model="scope.editRow.ENGINEER_ID"
                                  ></layui-multiselect>
                                </div>
                                <span class="project-inner-add" @click="addEngineer()" style="cursor: pointer">
                                  <i class="layui-icon layui-icon-add-circle" style="color: #00a0e9"></i>
                                  新增
                                </span>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">是否更换备件：</label>
                                <div class="layui-input-inline" style="width: 4%" @click="isNeed('NEED_REPAIR_PART')">
                                  <layui-switch :enabled="true" v-model="scope.editRow.NEED_REPAIR_PART">
                                  </layui-switch>
                                </div>
                              </div>
                              <div class="layui-form-item" v-show="scope.editRow.NEED_REPAIR_PART == 1">
                                <label class="layui-form-label">客户备件：</label>
                                <div class="layui-input-inline" style="width: 55%" id="repairCustomerPart">
                                  <layui-multiselect
                                    ref="customerRepairSelect"
                                    :single="false"
                                    :enabled="true"
                                    @selectChange="customerRepairChange($event)"
                                    :renderText="renderCustomerRepairPartText"
                                    table-name="YW_REPAIR_PART"
                                    text-field="REPAIR_PART_NAME"
                                    value-field="REPAIR_PART_ID"
                                    :show-null-option="true"
                                    :enable-search="true"
                                    v-model="scope.editRow.CLIENT_REPAIR_PART"
                                  ></layui-multiselect>
                                </div>
                              </div>
                              <div class="layui-form-item" v-if="scope.editRow.NEED_REPAIR_PART == 1">
                                <label class="layui-form-label">自有备件：</label>
                                <div class="layui-input-inline" style="width: 55%" id="repairPart">
                                  <layui-multiselect
                                    :single="false"
                                    :enabled="true"
                                    :renderText="renderRepairPartText"
                                    table-name="YW_REPAIR_PART"
                                    text-field="REPAIR_PART_NAME"
                                    value-field="REPAIR_PART_ID"
                                    :show-null-option="true"
                                    :queryCondition="{ REPAIR_PART_TYPE: '1' }"
                                    :enable-search="true"
                                    v-model="scope.editRow.YW_REPAIR_PART_ID"
                                  ></layui-multiselect>
                                </div>
                              </div>
                              <div class="layui-form-item" v-if="scope.editRow.NEED_REPAIR_PART == 1">
                                <label class="layui-form-label">备件收入金额：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <input
                                    type="number"
                                    v-model="scope.editRow.INCOME_REPAIR_PART_AMOUNT"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="INCOME_REPAIR_PART_AMOUNT"
                                    placeholder="请输入备件收入金额"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item" v-if="scope.editRow.NEED_REPAIR_PART == 1">
                                <label class="layui-form-label">备件支出金额：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <input
                                    type="number"
                                    v-model="scope.editRow.EXPENSES_REPAIR_PART_AMOUNT"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="EXPENSES_REPAIR_PART_AMOUNT"
                                    placeholder="请输入备件支出金额"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label"><span class="x-red">*</span>描述：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <textarea
                                    v-model="scope.editRow.SERVICE_DESCRIPTION"
                                    class="layui-textarea"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="layui-form-item-right">
                            <div class="pub-form">
                              <!-- <div class="layui-form-item">
                                <label class="layui-form-label"><span class="x-red">*</span>标准处理时间：</label>
                                <div class="layui-input-inline" style="width: 55%;">
                                  <layui-datetimerange
                                    :isDefaultVal="true"
                                    class="dateRange"
                                    name="TIME_RANGE"
                                    v-model="scope.editRow.TIME_RANGE"
                                    @dateChange="handleDateChange($event)"
                                  ></layui-datetimerange>
                                </div>
                              </div> -->
                              <div class="layui-form-item">
                                <label class="layui-form-label"><span class="x-red">*</span>标准处理时长(h)：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <!-- <label
                                    v-text="scope.editRow.STANDARD_PROCESSING_TIME"
                                    style="height: 32px;line-height: 32px;"
                                  ></label> -->
                                  <input
                                    type="text"
                                    v-model="scope.editRow.STANDARD_PROCESSING_TIME"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="STANDARD_PROCESSING_TIME"
                                    placeholder="请输入标准处理时长"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label"><span class="x-red">*</span>预约时间：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <layui-datetime
                                    name="APPOINTMENT_TIME"
                                    v-model="scope.editRow.APPOINTMENT_TIME"
                                    placeholder="预约时间"
                                  ></layui-datetime>
                                </div>
                              </div>

                              <div class="layui-form-item">
                                <label class="layui-form-label">是否临采：</label>
                                <div class="layui-input-inline" style="width: 4%" @click="isNeed('NEED_PURCHASING')">
                                  <layui-switch :enabled="true" v-model="scope.editRow.NEED_PURCHASING"> </layui-switch>
                                </div>
                              </div>
                              <div class="layui-form-item" v-if="scope.editRow.NEED_PURCHASING == 1">
                                <label class="layui-form-label">产品名称：</label>
                                <div class="layui-input-inline" style="width: 55%" id="proctName">
                                  <input
                                    type="text"
                                    v-model="scope.editRow.PRODUCT_NAME"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="PRODUCT_NAME"
                                    placeholder="请输入产品名称"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item" v-if="scope.editRow.NEED_PURCHASING == 1">
                                <label class="layui-form-label">产品型号：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <input
                                    type="text"
                                    v-model="scope.editRow.PRODUCT_MODEL"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="PRODUCT_MODEL"
                                    placeholder="请输入产品型号"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item" v-if="scope.editRow.NEED_PURCHASING == 1">
                                <label class="layui-form-label">产品序列号：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <input
                                    type="text"
                                    v-model="scope.editRow.PRODUCT_SERIAL"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="PRODUCT_SERIAL"
                                    placeholder="请输入产品序列号"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item" v-if="scope.editRow.NEED_PURCHASING == 1">
                                <label class="layui-form-label">产品支出金额：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <input
                                    type="number"
                                    min="0"
                                    v-model="scope.editRow.PRODUCT_EXPENSES_AMOUNT"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="PRODUCT_EXPENSES_AMOUNT"
                                    placeholder="请输入产品支出金额"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item" v-if="scope.editRow.NEED_PURCHASING == 1">
                                <label class="layui-form-label">产品收入金额：</label>
                                <div class="layui-input-inline" style="width: 55%">
                                  <input
                                    type="number"
                                    min="0"
                                    v-model="scope.editRow.PRODUCT_INCOME_AMOUNT"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="PRODUCT_INCOME_AMOUNT"
                                    placeholder="请输入产品收入金额"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="layui-form-item-one">
                          <div class="layui-form-item">
                            <label class="layui-form-label">附件：</label>
                            <div class="layui-input-inline" style="width: 80%">
                              <layui-listfileupload v-model="scope.editRow.FJ_ID" targetEl=".siteForm">
                                <template slot-scope="{ scope }">
                                  <div class="layui-upload">
                                    <button type="button" @click="scope.upload()" class="layui-upload-btn">
                                      <i class="layui-icon layui-icon-addition"></i> 本地上传
                                    </button>
                                    <button
                                      type="button"
                                      @click="scope.uploadFromStorage()"
                                      class="layui-upload-btn"
                                      style="margin-left: 20px"
                                    >
                                      <i class="layui-icon layui-icon-addition"></i> 资料库上传
                                    </button>
                                    <small class="layui-upload-muted">（单个不超过50M）</small>
                                  </div>
                                </template>
                              </layui-listfileupload>
                            </div>
                          </div>
                        </div>
                        <div v-if="type === 'gc'">
                          <div class="layui-form-item bpm-thumb-box">
                            <label for="" class="layui-form-label">工作流程：</label>
                            <div class="layui-input-inline">
                              <bpm
                                ref="refBpm"
                                type="select"
                                style="max-height: 500px"
                                :selected="bpmSelNodeId"
                                :currentSelect="bpmSelCurrent"
                                :bpmData="bpmInfo.data"
                                :isDisabledFn="bpmDisabledFn"
                              />
                            </div>
                          </div>
                          <div class="layui-form-item show-content">
                            <label for="" class="layui-form-label">总备注：</label>
                            <div class="layui-input-inline" style="width: calc(100% - 180px)">
                              {{ bpmInfo.totalBZ || '-' }}
                            </div>
                          </div>
                          <div class="layui-form-item show-content">
                            <label for="" class="layui-form-label">流程附件：</label>
                            <div class="layui-input-inline bpmFile">
                              <div v-for="item in bpmInfo.classFiles" :key="item.node_name">
                                <span>{{ item.node_name }}</span>
                                <layui-fileupload ref="bpmFile" v-model="item.files" :enabled="false" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </layui-collapse>
                  <layui-collapse ref="collapse2" class="">
                    <div class="layui-colla-item">
                      <h2 class="layui-colla-title">服务请求基本信息</h2>
                      <div class="layui-colla-content layui-show">
                        <div class="layui-form-item-two layui-form-column">
                          <div class="layui-form-colun-inner">
                            <div class="layui-form-item-left">
                              <div class="pub-form">
                                <div class="layui-form-item">
                                  <label class="layui-form-label">服务请求单编号：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.WORK_ORDER_NUM }} </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">项目经理名称：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.MANAGER_NAME }} </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">项目经理电话：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.MANAGER_PHONE }} </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">服务方式：</label>
                                  <label class="layui-form-label right"
                                    >{{ workOrderDetail.WORK_ORDER_METHOD_DESC }}
                                  </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">服务请求单来源：</label>
                                  <label class="layui-form-label right"
                                    >{{ workOrderDetail.BILL_SOURCE_METHOD_DESC }}
                                  </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">服务单类型：</label>
                                  <label class="layui-form-label right"
                                    >{{ workOrderDetail.WORK_ORDER_TYPE_DESC }}
                                  </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">故障类型：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.WRONG_TYPE_DESC }} </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">SLA等级：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.SLA_LEVEL }}</label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">客户联系人：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.CLIENT_PERSON }} </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">客户联系人电话：</label>
                                  <label class="layui-form-label right"
                                    >{{ workOrderDetail.CLIENT_PERSON_PHONE }}
                                  </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">描述：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.DESCRIPTION }} </label>
                                </div>
                              </div>
                            </div>
                            <div class="layui-form-item-right" v-if="workOrderDetail.ORDER_STATE > 4">
                              <div class="pub-form">
                                <div class="layui-form-item">
                                  <label class="layui-form-label">收入金额：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.INCOME_AMOUNT }} </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">收入费用状态：</label>
                                  <label class="layui-form-label right"
                                    >{{ workOrderDetail.INCOME_AMOUNT_TYPE_DESC }}
                                  </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">收入票据状态：</label>
                                  <label class="layui-form-label right"
                                    >{{ workOrderDetail.INCOME_BILL_TYPE_DESC }}
                                  </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">支出金额：</label>
                                  <label class="layui-form-label right">{{ workOrderDetail.EXPENSES_AMOUNT }} </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">支出费用状态：</label>
                                  <label class="layui-form-label right"
                                    >{{ workOrderDetail.EXPENSES_AMOUNT_TYPE_DESC }}
                                  </label>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">支出票据状态：</label>
                                  <label class="layui-form-label right"
                                    >{{ workOrderDetail.EXPENSES_BILL_TYPE_DESC }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="layui-form-bottom">
                          <div class="layui-form-item">
                            <label class="layui-form-label">附件：</label>
                            <label class="layui-input-inline" style="width: 80%">
                              <layui-listfileupload
                                v-model="workOrderDetail.ORDER_FJ_ID"
                                targetEl=".siteForm"
                                :enabled="false"
                              >
                              </layui-listfileupload>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="layui-colla-item">
                      <h2 class="layui-colla-title">服务商信息</h2>
                      <div class="layui-colla-content layui-show">
                        <div class="layui-form-item-two">
                          <div class="layui-form-item-left">
                            <div class="layui-form-item">
                              <label class="layui-form-label">服务商名称：</label>
                              <label class="layui-form-label right">{{ serviceRow.SERVICE_NAME }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">服务商性质：</label>
                              <label class="layui-form-label right">{{ serviceRow.SERVICE_NATURE_DESC }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">服务商类型：</label>
                              <label class="layui-form-label right">{{ serviceRow.SERVICE_TYPE_DESC }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">联系电话：</label>
                              <label class="layui-form-label right">{{ serviceRow.PHONE_NUM }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">所属地：</label>
                              <label class="layui-form-label right">{{
                                (serviceRow.PROVINCE ? serviceRow.PROVINCE_DESC : '') +
                                '' +
                                (serviceRow.CITY ? serviceRow.CITY_DESC : '') +
                                '' +
                                (serviceRow.DISTRICT ? serviceRow.DISTRICT_DESC : '')
                              }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">地址：</label>
                              <label class="layui-form-label right">{{ serviceRow.ADDRESS }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">备注：</label>
                              <label class="layui-form-label right">{{ serviceRow.BZ }}</label>
                            </div>
                          </div>
                          <div class="layui-form-item-right">
                            <div class="layui-form-item">
                              <label class="layui-form-label">身份证号：</label>
                              <label class="layui-form-label right">{{ serviceRow.ID_CARD }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">是否开票：</label>
                              <label class="layui-form-label right">{{ serviceRow.IS_BILL_DESC }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">纳税人识别号：</label>
                              <label class="layui-form-label right">{{ serviceRow.TAXPAPYER_NUM }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">开户行：</label>
                              <label class="layui-form-label right">{{ serviceRow.BANK }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">银行卡号：</label>
                              <label class="layui-form-label right">{{ serviceRow.BANK_NUM }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="layui-colla-item">
                      <h2 class="layui-colla-title">客户信息</h2>
                      <div class="layui-colla-content layui-show">
                        <div class="layui-form-item-two">
                          <div class="layui-form-item-left" style="width: 55%">
                            <div class="layui-form-item">
                              <label class="layui-form-label">客户名称：</label>
                              <label class="layui-form-label right">{{ workOrderDetail.CLIENT_NAME }} </label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">门店名称：</label>
                              <label class="layui-form-label right">{{ workOrderDetail.BRAND_NAME }} </label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">品牌名称：</label>
                              <label class="layui-form-label right">{{ workOrderDetail.STORE_NAME }} </label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">店长姓名：</label>
                              <label class="layui-form-label right">{{ workOrderDetail.STORE_MANAGER }} </label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">所属地：</label>
                              <label class="layui-form-label right">{{
                                (workOrderDetail.STORE_P ? workOrderDetail.STORE_P_DESC : '') +
                                '' +
                                (workOrderDetail.STORE_C ? workOrderDetail.STORE_C_DESC : '') +
                                '' +
                                (workOrderDetail.STORE_D ? workOrderDetail.STORE_D_DESC : '')
                              }}</label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">地址：</label>
                              <label class="layui-form-label right">{{ workOrderDetail.STORE_A }} </label>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">备注：</label>
                              <label class="layui-form-label right">{{ workOrderDetail.STORE_BZ }} </label>
                            </div>
                          </div>
                          <div class="layui-form-item-right" style="width: 45%">
                            <div class="layui-form-item" style="height: 100%">
                              <div id="container" class="map-box"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 设备信息 -->
                    <div class="layui-colla-item">
                      <h2 class="layui-colla-title">设备信息</h2>
                      <div class="device layui-colla-content layui-show">
                        <layui-table
                          ref="deviceTable"
                          :lazy="true"
                          table-name="YW_DEVICE"
                          :defaultCondition="{ WORK_ORDER_ID: workOrderId }"
                          :page-size="5"
                          :page-range="2"
                          :page-options="[5, 10, 20, 50, 100]"
                          :skin="'line'"
                          :height="height"
                          :sort="['ID:DESC']"
                        >
                          <div>
                            <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                            <layui-tableconfig :config="deviceTableList"></layui-tableconfig>
                          </div>
                        </layui-table>
                      </div>
                    </div>
                  </layui-collapse>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="close()">关 闭</button>
                    <button class="layui-btn" title="保 存" @click="saveForm()">保 存</button>
                    <button
                      class="layui-btn"
                      style="background: #179f75"
                      title="派单"
                      @click="sendList()"
                      v-if="scope.editRow.SERVICE_STATE == '0' || !scope.editRow.SERVICE_STATE"
                    >
                      派 单
                    </button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
    <engineer-form v-if="engineerForm" :visible.sync="engineerForm" :formType="formType" :formFrom="formFrom" />
  </div>
</template>

<script>
import bpm from '../bpm/bpm.vue'
import request from '@/network/networkconfig'
import engineerForm from '../../person/engineerManage/engineerForm'

/**
 * 现场服务单-编辑
 *
 */
export default {
  provide() {
    return {
      source: 'siteManage',
    }
  },
  components: {
    bpm,
    engineerForm,
  },
  props: {
    height: { type: String, default: '260' },
  },
  data() {
    return {
      title: '',
      info: '',
      type: 'yw',
      form_rule: {
        F_WORK_ORDER_ID: {
          required: { message: '服务请求单编号不能为空' },
        },
        SERVICE_ID: {
          required: { message: '服务商不能为空' },
        },
        ENGINEER_ID: {
          required: { message: '工程师不能为空' },
        },
        STANDARD_PROCESSING_TIME: {
          required: { message: '标准处理时长不能为空' },
        },
        APPOINTMENT_TIME: {
          required: { message: '预约时间不能为空' },
        },
        SERVICE_DESCRIPTION: {
          required: { message: '描述不能为空' },
        }
      },
      workOrderDetail: {},
      repairPartName: '',
      map: null,
      marker: null,
      queryConditionVal: '',
      workOrderId: '',
      deviceTableList: [
        { field: 'ORDER_TIME', title: '订单日期', width: 150 },
        { field: 'ORDER_ID', title: '订单编号', width: 130 },
        { field: 'BUSINESS_TYPE', title: '业务类别', width: 130 },
        { field: 'CLIENT', title: '客户', width: 200 },
        { field: 'BZ2', title: '备注', width: 200 },
        { field: 'COMMODITY_ID', title: '商品编码', width: 130 },
        { field: 'COMMODITY_NAME', title: '商品名称', width: 130 },
        { field: 'COMMODITY_TYPE', title: '商品型号', width: 130 },
        { field: 'COMMODITY_BRAND', title: '商品品牌', width: 130 },
        { field: 'MEASURE', title: '单位', width: 80 },
        { field: 'NUM', title: '数量', width: 80 },
        { field: 'WAREHOUSE', title: '仓库', width: 130 },
        { field: 'BZ', title: '备注', width: 130 },
      ],
      bpmInfo: {
        totalBZ: '',
        totalFiles: '',
        classFiles: [],
        data: [],
      },
      /** 其他流程已选节点 */
      bpmSelNodeId: [],
      /** 当前选中节点 */
      bpmSelCurrent: [],
      work_order_enabled: true,
      scrollTop: 0,
      serviceRow: {}, //服务商信息,
      engineerForm: false,
      fromFrom: '',
      input_disabled: false,
    }
  },
  activated() {
    if (this.refreshServiceSelect) {
      this.refreshServiceSelect = false
      this.$refs.serviceSelect.refreshAsyncData()
    }
    if (this.scrollTop) {
      $('.core').animate({ scrollTop: this.scrollTop }, 0)
    }
    //如果二级菜单不展示，底部样式修改
    if (!$('.layui-side-scroll').is(':visible')) {
      $('.layui-footer').css('left', '0')
    } else {
      $('.layui-footer').removeAttr('style')
    }
  },
  mounted() {
    this.tableForm = this.$refs.tableForm
    this.workOrderSelect = this.$refs.workOrderSelect
    this.engineer = this.$refs.engineerSelect

    if (this.tabParam) {
      this.siteRequest = this.tabParam.siteRequest
      if (this.tabParam.title) {
        this.title = this.tabParam.title
        this.input_disabled = this.tabParam.input_disabled
      }
      this.type = this.tabParam.type
      this.$nextTick(() => {
        if (this.tabParam.editRow) {
          //编辑    TODO 编辑没有做服务单数据过滤，ORDER_STATE = '1'
          this.tableForm.editRow = this.tabParam.editRow
          this.workOrderDetail = this.tabParam.editRow
          if (this.tableForm.editRow.LNG && this.tableForm.editRow.LAT) {
            var arriveCoor = []
            arriveCoor.push(this.tableForm.editRow.LNG)
            arriveCoor.push(this.tableForm.editRow.LAT)
            this.addMarker(arriveCoor)
          }
          this.workOrderId = this.tableForm.editRow.WORK_ORDER_ID
        } else {
          //新增
          this.tableForm.editRow.STANDARD_PROCESSING_TIME = '3'
        }
        /**
         * 服务请求单状态(1.客服处理  2.现场处理 3.内部验收  4.服务回访 5.对账付款 6.已关闭 ) 0. 可关闭
         *
         */
        this.workOrderSelect.condition['ORDER_STATE:1'] = '1,2,3'
        this.workOrderSelect.condition['HISTORY_WORK:'] = '0'
        if (this.type == 'yw') {
          this.info = '现场服务运维单基本信息'
          this.workOrderSelect.condition.WORK_ORDER_CATEGORY = '1'
        } else if (this.type == 'gc') {
          this.info = '现场服务工程单基本信息'
          this.workOrderSelect.condition.WORK_ORDER_CATEGORY = '2'
        }
        if (this.tabParam.editRow && (this.tabParam.editRow.AFRESH_DISPATCH || this.tabParam.editRow.DISPATCH)) {
          //重新派单,不过滤ORDER_STATE = 1
          this.work_order_enabled = false //服务单编号不可编辑
        }

        this.workOrderSelect.condition['WORK_ORDER_METHOD:1'] = '1, 3' // 显示“上门服务”单  显示“第三方服务”单

        this.workOrderSelect.refreshAsyncData()
      })
      this.tableObj = this.tabParam.tableObj
    }
    // });
    var that = this
    $('.core').scroll(function (event) {
      that.scrollTop = $('.core').scrollTop()
    })

    this.refreshServiceSelect = false
    //监听新增服务商
    this.$bus.$on('serviceRequest_inner_addService', () => {
      this.refreshServiceSelect = true
    })

    if (this.input_disabled) {
      this.workOrderChange(this.tabParam.editRow, true)
    }
  },
  methods: {
    servicerSelectChange(row) {
      //刷新
      this.tableForm.editRow.SERVICE_ID_DESC = row[0].name
      this.engineer.condition.SERVICE_ID = row[0]._row.SERVICE_ID
      this.engineer.refreshAsyncData()
      this.servicerModelChange(row)

      if (row && row.length > 0) {
        this.queryEngineerListByServiceId(row[0]._row.SERVICE_ID)
      }
    },
    queryEngineerListByServiceId(service_id) {
      let _this = this
      request({
        url: '/yw/workOrder/queryEngineerListByServiceId/' + service_id,
        method: 'post',
      }).then(
        (result) => {
          if (result.result.errorMsg) {
            this.layer.openAlert(result.result[0].errorMsg)
          } else {
            // 如果只有一个工程师，自动回显这一条
            if (result.result && result.result.length === 1) {
              this.$set(this.$refs.tableForm.editRow, 'ENGINEER_ID', result.result[0].ENGINEER_ID)
            }
          }
        },
        null,
        { targetEl: $('body') }
      )
    },
    servicerModelChange(row) {
      this.serviceRow = row.length > 0 ? row[0]._row : {}
    },
    renderServiceText(row) {
      var width = $('#servicer').width() - 20 - 12 - 30
      var content = ''
      if (row['SERVICE_NATURE']) {
        content = row['SERVICE_NAME'] + '【' + row['SERVICE_NATURE_DESC'] + '】'
      } else {
        content = row['SERVICE_NAME']
      }
      return (
        '<div style="white-space: nowrap;max-width:' +
        width +
        'px;overflow: hidden;" title="' +
        content +
        '">' +
        content +
        '</div>'
      )
    },
    //新增服务商
    addService() {
      this.baseComponent.smartLoadComponent('serviceForm', {
        tableObj: this.tableObj,
        formType: 'add',
        title: '新增服务商',
        from: 'serviceRequestForm',
      })
    },
    addEngineer() {
      this.engineerForm = true
      this.formType = 'add'
      this.formFrom = 'siteManage'
    },
    workOrderChange(row = {}, input_disabled) {
      if (!input_disabled) {
        if (row[0]) {
          row = row[0]._row
          this.workOrderDetail = row
        } else {
          row = this.workOrderDetail
        }
      }

      this.filterCustomerRepair(row) // 为了做客户备件联动，选择了服务请求单编号 就要进行筛选
      let editRow = this.tabParam.editRow || {}
      // 获取工程模板信息
      if (this.type === 'gc' && row.TEMPLATE_ID) {
        // row.TEMPLATE_ID
        // 模板详情
        this.api
          .queryList('YW_TEMPLATE', { p2: { 'TEMPLATE_ID:0': row.TEMPLATE_ID } }, 'getBpmTplDetail')
          .then((response) => {
            var data = response.result[0] || { TEMPLATE_NODE: undefined }
            let bpmInfo = { ...data, TEMPLATE_NODE: undefined }
            if (data.TEMPLATE_NODE) {
              bpmInfo.data = JSON.parse(data.TEMPLATE_NODE)
            } else {
              bpmInfo.data = []
            }
            this.bpmInfo = bpmInfo

            let t = this.$refs['refBpm'].getTplNodeInfo(bpmInfo)
            bpmInfo.totalBZ = t.totalBZ
            if (t.totalFiles) {
              bpmInfo.totalFiles = t.totalFiles
              bpmInfo.classFiles = t.classFiles
            } else {
              // this.$refs['bpmFile'].setValue('')
            }
          })

        // 相同服务请求单下，所有现场服务单中已分配的 NodeId
        // 其他现场服务单占用节点，禁用
        // 本现场服务单节点编辑时，可用
        this.api
          .queryList(
            'YW_SERVICE_ORDER_V1',
            {
              p2: { 'F_WORK_ORDER_ID:0': row.WORK_ORDER_ID },
              p9: 'SERVICE_ORDER_ID,WORK_ORDER_ID,TEMPLATE_NODEID,TEMPLATE_ID',
            },
            'getOrderSeledNodes'
          )
          .then((response) => {
            let rd = response.result || []
            let otherO = [],
              thisO = []
            rd.map((v) => {
              if (!v.TEMPLATE_NODEID) return

              if (v.SERVICE_ORDER_ID === editRow.SERVICE_ORDER_ID) {
                v.TEMPLATE_NODEID.split(',').map((n) => {
                  if (!n) return
                  thisO.push(n)
                })
              } else {
                v.TEMPLATE_NODEID.split(',').map((n) => {
                  if (!n) return
                  otherO.push({ id: n, ...v })
                })
              }
            })
            this.bpmSelNodeId = otherO
            this.bpmSelCurrent = thisO
          })
      }

      //门店定位
      if (row.LNG && row.LAT) {
        var arriveCoor = []
        arriveCoor.push(row.LNG)
        arriveCoor.push(row.LAT)
        try {
          this.addMarker(arriveCoor)
        } catch (error) {
          console.log('addMarker: ', error)
        }
      }
      //查询设备信息
      this.workOrderId = row.WORK_ORDER_ID
      let deviceTable = this.$refs.deviceTable
      this.$nextTick(() => {
        deviceTable.load()
      })
    },
    customerRepairChange(row = {}) {
      if (row[0]) {
        row = row[0]._row
        if (row.REPAIR_PART_TYPE == '2') {
          this.filterCustomerRepair(row)
        }
      }
    },
    bpmDisabledFn: function (param) {
      let flag = false
      // 默认待接单
      if (['0', '1', '2', '3', '4', '5'].indexOf((this.tabParam.editRow || {}).SERVICE_STATE || '1') === -1) {
        // 验收前可以修改 - 验收后禁用
        flag = true
      } else {
        // 内置禁止规则函数
        // flag = param.sourceFn(param.node)
        // flag = !!this.bpmSelNodeId.filter(n => node.id == n.id).length
      }
      return flag
    },
    renderWorkOrderText(row) {
      if (row['WORK_ORDER_NUM']) {
        return '【编号】' + row['WORK_ORDER_NUM'] + '【门店】' + row['STORE_NAME']
      }
    },

    renderClientText(row) {
      if (row) {
        if (!row.STORE_ID) {
          return '--请选择--'
        } else {
          var arr = []
          arr.push('门店【 ' + row['STORE_NAME'] + ' 】')
          arr.push('客户【 ' + row['CLIENT_NAME'] + ' 】')
          arr.push('品牌【 ' + row['BRAND_NAME'] + ' 】')
          this.storeName = arr.join(' ')
          return arr.join(' ')
        }
      }
    },

    renderEngineerText(row) {
      if (row) {
        var width = $('#engineer').width() - 20 - 12 - 30
        var content = ''
        if (row['ENGINEER_PHONE']) {
          content = row['ENGINEER_NAME'] + '【' + row['ENGINEER_PHONE'] + '】'
        } else {
          content = row['ENGINEER_NAME']
        }
        return (
          '<div style="white-space: nowrap;max-width:' +
          width +
          'px;overflow: hidden;" title="' +
          content +
          '">' +
          content +
          '</div>'
        )
      }
    },
    // 自选备件
    renderRepairPartText(row) {
      if (row) {
        var width = $('#repairPart').width() - 20 - 12 - 30
        var titleArr = []
        var arr = []
        arr.push('<span style="font-weight:bold;color:black">备件名称：</span>' + row.REPAIR_PART_NAME)
        titleArr.push('备件名称：' + row.REPAIR_PART_NAME)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">序列号：' + '</span>' + row.REPAIR_PART_SERIAL
        )
        titleArr.push('序列号：' + row.REPAIR_PART_SERIAL)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">型号：' + '</span>' + row.REPAIR_PART_MODEL
        )
        titleArr.push('型号：' + row.REPAIR_PART_MODEL)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">仓库：' + '</span>' + row.REPAIR_PART_STORE_DESC
        )
        titleArr.push('仓库：' + row.REPAIR_PART_STORE_DESC)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">金额：' + '</span>' + row.REPAIR_PART_MONEY
        )
        titleArr.push('金额：' + row.REPAIR_PART_MONEY)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">类别：' +
            '</span>' +
            row.REPAIR_PART_CATEGORY_DESC
        )
        titleArr.push('类别：' + row.REPAIR_PART_CATEGORY_DESC)
        return (
          '<div style="white-space: nowrap;max-width:' +
          width +
          'px;overflow: hidden;" title="' +
          titleArr.join(' ') +
          '">' +
          arr.join('') +
          '</div>'
        )
      }
    },
    // 客户备件
    renderCustomerRepairPartText(row) {
      if (row) {
        var width = $('#repairCustomerPart').width() - 20 - 12 - 30
        var titleArr = []
        var arr = []
        arr.push('<span style="font-weight:bold;color:black">备件名称：</span>' + row.REPAIR_PART_NAME)
        titleArr.push('备件名称：' + row.REPAIR_PART_NAME)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">序列号：' + '</span>' + row.REPAIR_PART_SERIAL
        )
        titleArr.push('序列号：' + row.REPAIR_PART_SERIAL)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">型号：' + '</span>' + row.REPAIR_PART_MODEL
        )
        titleArr.push('型号：' + row.REPAIR_PART_MODEL)
        return (
          '<div style="white-space: nowrap;max-width:' +
          width +
          'px;overflow: hidden;" title="' +
          titleArr.join(' ') +
          '">' +
          arr.join('') +
          '</div>'
        )
      }
    },
    engineerChange(row = {}) {
      this.tableForm.editRow.ENGINEER_ID_DESC = row[0].name
    },
    repairPartChange() {
      var name = this.repairPartName
      this.repairPartName = null
      this.repairPartName = name
    },
    isNeed(status) {
      // NEED_REPAIR_PART
      var flag = this.tableForm.editRow[status]
      if (flag != 1) {
        this.tableForm.editRow[status] = ''
        this.clearRepair(status)
      }
      if (flag && status == 'NEED_REPAIR_PART') {
        // 只有scope.editRow.NEED_REPAIR_PART == 1"  客户备件才进行筛选
        this.filterCustomerRepair(this.workOrderDetail)
      }
    },
    clearRepair(status) {
      if (status == 'NEED_REPAIR_PART') {
        this.tableForm.editRow.CLIENT_REPAIR_PART = ''
        this.tableForm.editRow.YW_REPAIR_PART_ID = ''
        this.tableForm.editRow.INCOME_REPAIR_PART_AMOUNT = ''
        this.tableForm.editRow.EXPENSES_REPAIR_PART_AMOUNT = ''
      } else {
        this.tableForm.editRow.PRODUCT_NAME = ''
        this.tableForm.editRow.PRODUCT_MODEL = ''
        this.tableForm.editRow.PRODUCT_SERIAL = ''
        this.tableForm.editRow.PRODUCT_EXPENSES_AMOUNT = ''
        this.tableForm.editRow.PRODUCT_INCOME_AMOUNT = ''
      }
    },
    filterCustomerRepair(row) {
      this.$refs.customerRepairSelect.queryCondition.CLIENT_ID = row.CLIENT_ID_
      this.$refs.customerRepairSelect.queryCondition.BRAND_ID = row.BRAND_ID
      this.$refs.customerRepairSelect.queryCondition.REPAIR_PART_TYPE = '2'
      this.$refs.customerRepairSelect.refreshAsyncData()
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      this.baseComponent.clickSecondMenuByName('siteManage')
      if (this.tabParam.from == 'dispatchForm') {
        this.$bus.$emit('dispatchForm')
      } else {
        if (this.tableObj) {
          this.siteRequest.tab = this.type
          this.tableObj.pageInfo.pageIndex = 1
          this.tableObj.load()
        }
      }
    },
    close() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      if (this.tabParam.from == 'dispatchForm') {
        this.baseComponent.currentComponent = this.tabParam.sourceMenu
      } else {
        this.baseComponent.clickSecondMenuByName('siteManage')
      }
    },
    // 实例化点标记
    addMarker(arriveCoor) {
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 10,
      })
      //鹰眼
      //this.map.addControl(new AMap.OverView());
      //比例尺
      this.map.addControl(new AMap.Scale())
      //工具条
      this.map.addControl(new AMap.ToolBar({ liteStyle: true }))
      this.marker = new AMap.Marker({
        icon: '', //图片ip
        imageSize: '20px',
        position: arriveCoor,
        offset: new AMap.Pixel(-13, -30),
        // 设置是否可以拖拽
        draggable: false,
        cursor: 'move',
        // 设置拖拽效果
        raiseOnDrag: false,
      })
      this.marker.setMap(this.map)
      this.map.setFitView()
    },
    //保存
    saveForm() {
      if (this.type === 'gc') {
        let refBpm = this.$refs.refBpm
        let ids = refBpm.querySelect().join(',')
        this.tableForm.editRow.TEMPLATE_NODEID = ids // 是否有节点选中
      }
      if (!this.tableForm.editRow.SERVICE_STATE) {
        //处理草稿状态逻辑
        this.tableForm.editRow.SERVICE_STATE = '0'
      }
      if (this.tableForm.editRow.AFRESH_DISPATCH) {
        this.$refs.tableForm.requestUniqueId = 'addServiceOrder'
      }
      // todo 返单管理来的
      if (this.tabParam.requestId === 'backOrder') {
        this.$refs.tableForm.requestUniqueId = 'backOrder'
        this.tableForm.editRow.B_BACK_ORDER = '1'
      }

      this.$refs.tableForm.callableSave('YW_SERVICE_ORDER', true)
    },
    // 派单
    sendList() {
      this.$refs.tableForm.requestUniqueId = 'addServiceOrder'
      if (this.type === 'gc') {
        let refBpm = this.$refs.refBpm
        let ids = refBpm.querySelect().join(',')
        this.tableForm.editRow.TEMPLATE_NODEID = ids
      }
      // todo 不太懂这个校验是干啥 永远都是空的
      // if(!this.tableForm.editRow.TEMPLATE_NODEID && this.type === 'gc'){
      //   this.layer.openAlert("工作流程不能为空");
      //     return false
      // }
      this.$refs.tableForm.callableSave('YW_SERVICE_ORDER', true)
    },
  },
}
</script>

<style lang="postcss">
.core .bpm-thumb-box {
  display: flex;

  & > .layui-input-inline {
    margin: 0;
    flex: 1;
    width: 0;
    border: 1px solid #ddd;
  }
}
</style>
<style scoped>
.project-inner-add {
  height: 34px !important;
  line-height: 34px !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/siteManage/siteForm_v2.vue